import { gql } from '@apollo/client'

export const TASK_FRAGMENT = gql`
  fragment TaskFragment on Task {
    id
    name
    type
    project
    start
    end
    mode
    notes
    progress
    assignee
    displayOrder
    startDependencies
    endDependencies
    styles {
      backgroundColor
    }
    duration {
      months
      days
    }
    offset {
      months
      days
    }
  }
`
